import React from 'react';
import { Link } from 'react-router-dom';
import LazyImage from './common/LazyImage';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <LazyImage 
            src="/logo.png" 
            alt="MWA Logo" 
            className="footer-logo" 
            showSpinner={false}
            style={{ minHeight: '32px', minWidth: '32px', backgroundColor: 'transparent' }}
          />
          <span className="footer-brand">MWA</span>
        </div>
        
        <div className="footer-center">
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-of-use">Terms</Link>
          <Link to="/cancellation-refund">Refunds</Link>
          <Link to="/shipping-policy">Shipping</Link>
        </div>
        
        <div className="footer-right">
          <a href="https://www.instagram.com/move_with_aman/" target="_blank" rel="noopener noreferrer" className="social-link instagram" title="Follow on Instagram">
            <i className="fab fa-instagram"></i>
            <span>@move_with_aman</span>
          </a>
          <a href="https://www.instagram.com/amargueflowindia/" target="_blank" rel="noopener noreferrer" className="social-link instagram" title="Follow on Instagram">
            <i className="fab fa-instagram"></i>
            <span>@amargueflowindia</span>
          </a>
          <a href="https://www.instagram.com/bachatalacultura/" target="_blank" rel="noopener noreferrer" className="social-link instagram" title="Follow on Instagram">
            <i className="fab fa-instagram"></i>
            <span>@bachatalacultura</span>
          </a>
          <span className="footer-copyright">© {currentYear}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 